import { render, staticRenderFns } from "./date-time-picker.new.vue?vue&type=template&id=2a596a37&scoped=true&"
import script from "./date-time-picker.new.vue?vue&type=script&lang=js&"
export * from "./date-time-picker.new.vue?vue&type=script&lang=js&"
import style0 from "./date-time-picker.new.vue?vue&type=style&index=0&id=2a596a37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a596a37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VContainer,VDatePicker,VFlex,VLayout,VMenu,VTextField,VTimePicker})
